import { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthProvider, ChatProvider, TOSProvider, GuardProvider, NotificationProvider } from '@carcareers/contexts';

export interface AppShellProps {
  children?: ReactNode;
}

export const AppShell: FC<AppShellProps> = ({ children }) => {
  return (
    <AuthProvider>
      <GuardProvider>
        <TOSProvider>
          <ChatProvider
            supabaseUrl={process.env.NX_SUPABASE_URL || ''}
            supabaseKey={process.env.NX_SUPABASE_API_KEY || ''}
          >
            <NotificationProvider>
              {children}
              <Outlet />
            </NotificationProvider>
          </ChatProvider>
        </TOSProvider>
      </GuardProvider>
    </AuthProvider>
  );
};

export default AppShell;
